import { UseQueryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { calculateShipmentValue } from "@/services/api/shipment";
import { logger } from "@/services/logger";

import { useAppSelector } from "../application/store";

const SHIPMENT_VALUE_QUERY_KEY = (storeId: string, clientId: string) =>
  `/shipment-value/${storeId}/${clientId}`;

export const useShipmentValue = (
  storeId: string,
  options?: UseQueryOptions<{ shipmentValue: number }>
) => {
  const queryClient = useQueryClient();
  const { user } = useAppSelector((store) => store.auth);
  const clientId = user?.cliente?._id;

  const { data, isLoading, isError } = useQuery<{ shipmentValue: number }>({
    queryKey: [SHIPMENT_VALUE_QUERY_KEY(storeId, clientId)],
    queryFn: () => calculateShipmentValue(storeId, clientId),
    retry: false,
    ...options,
    onError: (error) => {
      logger.error(error);
      queryClient.setQueriesData([SHIPMENT_VALUE_QUERY_KEY(storeId, clientId)], null);
      if (options?.onError) options?.onError(error);
    },
  });
  return {
    data,
    isError,
    isLoading,
  };
};
